import { onCLS, onINP, onLCP } from "web-vitals";

const reportWebVitals = (onPerfEntry?: any) => {
	if (onPerfEntry && onPerfEntry instanceof Function) {
		onCLS(onPerfEntry);
		onINP(onPerfEntry);
		onLCP(onPerfEntry);
	}
};

export default reportWebVitals;
